import CryptoJS from 'crypto-js'

// 讯飞语音识别配置
let config = {
    APPID: window.XFYY.APPID || '7be90dc9',
    APIKey: window.XFYY.APIKey || '5fad4c557225bfdef3293e8b1e208dbd',
    APISecret: window.XFYY.APISecret || 'ZThhNjdkMWVkODFmYjAzZDU3ZmFmNjVj',
    host: 'iat-api.xfyun.cn',
		url: 'wss://iat-api.xfyun.cn/v2/iat',
    path: '/v2/iat'
}

export function getConfig(){
	return config
}

export function getWebSocketUrl(){
	let host = config.host
	let algorithm = 'hmac-sha256'
	let headers = 'host date request-line'
	let date = new Date().toGMTString()
	let signatureSha = CryptoJS.HmacSHA256(`host: ${host}\ndate: ${date}\nGET /v2/iat HTTP/1.1`, config.APISecret)
	let signature = CryptoJS.enc.Base64.stringify(signatureSha)
	let authorizationOrigin = `api_key="${config.APIKey}", algorithm="${algorithm}", headers="${headers}", signature="${signature}"`
	let authorization = window.btoa(authorizationOrigin)
	return `wss://iat-api.xfyun.cn/v2/iat?authorization=${authorization}&date=${date}&host=${host}`
}